const steps = [
  {
    number: "1",
    title: "Import & Centralize",
    description: "Upload or integrate your loan portfolio via API or CSV.",
  },
  {
    number: "2",
    title: "AI Scoring & Segmentation",
    description: "Debtors are automatically prioritized by risk and DPD.",
  },
  {
    number: "3",
    title: "Automated Outreach & Escalation",
    description: "Smart workflows trigger SMS, WhatsApp, calls, and payment links.",
  },
  {
    number: "4",
    title: "Resolution Tracking",
    description: "Track PTPs, settlements, EMI plans, and payments in real time.",
  },
  {
    number: "5",
    title: "Analytics & Compliance Reporting",
    description: "Generate scheduled reports and audit logs instantly.",
  },
];

const StepCard = ({ step }) => (
  <div className="bg-white  rounded-[32px] p-3 flex flex-row gap-6 items-start shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]">
    <div className="bg-[#0284c7] rounded-3xl flex items-center justify-center shrink-0 w-16 h-16 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]">
      <span className="text-white text-center font-semibold text-2xl leading-8">
        {step.number}
      </span>
    </div>
    <div className="pt-2 flex flex-col gap-3 flex-1">
      <h3 className="text-[#111827] font-['SpaceGrotesk-Bold',_sans-serif] text-2xl leading-8 font-bold">
        {step.title}
      </h3>
      <p className="text-[#4b5563] font-normal text-lg leading-[29.25px]">
        {step.description}
      </p>
    </div>
  </div>
);

export default function ProcessSection() {
  return (
    <section className="bg-white pt-32 pb-14 px-5 md:px-20">
      <div className="max-w-[1400px] mx-auto px-0 md:px-8 flex flex-col gap-16 items-center">
        {/* Header */}
        <div className="flex flex-col gap-4 items-center justify-center w-full">
          <div className="bg-white rounded-full border border-[#bae6fd] pt-2 pr-4 pb-2 pl-4 shadow-sm">
            <span
              className="text-[#0369a1] font-bold text-xs leading-4 uppercase"
              style={{ letterSpacing: "0.6px" }}
            >
              Process
            </span>
          </div>
          <h2 className="text-[#111827] text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold max-w-5xl">
            From Delinquency to Recovery-
            <br />
            Simplified
          </h2>
        </div>

        {/* Steps — mobile: vertical list, desktop: snake/zigzag layout */}
        <div className="w-full relative">

          {/* Mobile: vertical list */}
          <div className="flex flex-col gap-6 md:hidden">
            {steps.map((step) => (
              <StepCard key={step.number} step={step} />
            ))}
          </div>

          {/* Desktop: snake layout */}
          <div className="hidden md:flex flex-col gap-8 relative">
            {/* SVG S-curve connector */}
            <svg
              className="absolute inset-0 left-10 top-10 w-full h-full pointer-events-none"
              style={{ opacity: 0.2 }}
              viewBox="0 0 1240 422"
              preserveAspectRatio="none"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.3"
                d="M498.519 0H1198C1221.2 0 1240 18.804 1240 42V163.75C1240 186.946 1221.2 205.75 1198 205.75H42C18.8041 205.75 0 224.554 0 247.75L0 380C0 403.196 18.804 422 42 422H349"
                stroke="#0284C7"
                strokeWidth="4"
              />
            </svg>

            {/* Row 1: Step 1 (left) | Step 2 (right) */}
            <div className="grid grid-cols-2 gap-10">
              <StepCard step={steps[0]} />
              <StepCard step={steps[1]} />
            </div>

            {/* Row 2: Step 4 (left) | Step 3 (right) — reversed for snake flow */}
            <div className="grid grid-cols-2 gap-10 py-16">
              <StepCard step={steps[3]} />
              <StepCard step={steps[2]} />
            </div>

            {/* Row 3: Step 5 centered */}
            <div className="flex absolute left-0 md:-bottom-32 lg:-bottom-28  -bottom-7 justify-center  w-full">
              <div className="w-1/2">
                <StepCard step={steps[4]} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
